
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/burgare/smashburgare",
      function () {
        return require("private-next-pages/burgare/smashburgare/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/burgare/smashburgare"])
      });
    }
  